export enum ConsentRequestStatus
{
    CREATED = "created",
    INITIATE_SUCCESS = "initiate_success",
    INITIATE_FAILED = "initiate_failed",
    USER_ACTION_COMPLETED = "user_action_completed",
    CONSENT_CAPTURED = "user_consent_completed",
    FAILED = "failed",
    DONE = "done"
}